module.exports = __webpack_public_path__ + "static/media/shipping_icon.775e8ddf.svg";